module.exports = __webpack_public_path__ + "static/media/logov1-transparent.674f2534.png";